export function getEmpowermentSVGLines({ whakarewa }: { whakarewa: string }) {
    if (!whakarewa) {
        return [];
    }
    
    return [
        { heading: "Empowerment" },
        { label: "Empowerment", text: whakarewa },
    ];
}